import React, { Component } from 'react';

import { getOnboardUser, postOnboardUser } from 'actions/redirectionActions';

import RegistrationForm from 'navigation/RegistrationForm';
import { updateLanguage } from 'react-localize-redux';

import { connect } from 'react-redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { BounceLoader } from 'halogenium';

import { AccentColor } from 'helpers/AccentColorHelper';
import InvalidInvitationToken from 'errors/InvalidInvitationToken';
import VerificationFailed from 'errors/VerificationFailed';
import {
  getTranslatedString,
  getCurrentLocale,
  getLandlordVerbiageOrTranslatedString,
} from 'helpers/i18n';
import { browserHistory } from 'react-router';

export default connect(
  store => {
    return {
      initialValues: store.redirection.onboardUser,
      invitationToken: store.redirection.invitation_token,
      userType: store.redirection.userType,
      greetingNameType: store.userTypes.greetingNameType,
    };
  },
  {
    getOnboardUser,
    postOnboardUser,
    updateLanguage,
  }
)(
  class UserOnboarding extends Component {
    constructor(props) {
      super(props);
      this.state = {
        errorMessage: null,
        isRegistering: true,
        showInvalidTokenErrorPage: false,
        showVerificationFailedPage: false,
        showLoading: true,
      };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.invitationToken && !this.props.invitationToken) {
        this.props.getOnboardUser(nextProps.invitationToken, nextProps.userType).then(response => {
          const error = response.value && response.value.error;
          if (error) {
            this.setState({
              showInvalidTokenErrorPage: true,
              showLoading: false,
            });
          } else {
            this.setState({ isRegistering: false, showLoading: false });
          }
          const languageCode = response.value && response.value.language_code;
          if (languageCode) {
            this.props.updateLanguage(languageCode);
            localStorage.setItem('locale', languageCode);
            this.forceUpdate();
          }
        });
      }
    }

    register = values => {
      this.setState({
        isRegistering: true,
      });
      values['language_code'] = getCurrentLocale();
      const query = browserHistory.getCurrentLocation().query;
      this.props.postOnboardUser(this.props.invitationToken, values, query.src).then(response => {
        const error = response.value && response.value.error;
        if (error && error.code === 'VERIFICATION_FAILED') {
          this.setState({
            showVerificationFailedPage: true,
          });
        } else if (error && error.code === 'commonPassword') {
          this.setState({
            errorMessage: error.message,
          });
        }
      });
    };

    render() {
      const style = {
        transactionCard: {
          color: '#424242 !important',
          fontFamily: '"Circular", sans-serif !important',
          height: '100%',
          overflow: 'hidden',
          borderRadius: '8px',
          padding: '15px',
          marginTop: '15px',
        },
      };

      if (this.state.showLoading)
        return <BounceLoader color={AccentColor()} style={{ margin: '0 100px' }} />;

      if (this.state.showInvalidTokenErrorPage) return <InvalidInvitationToken />;

      if (this.state.showVerificationFailedPage) return <VerificationFailed />;

      const submitMessage = this.state.isRegistering
        ? getTranslatedString('onboarding.tenant.creatingAccount')
        : getTranslatedString('onboarding.tenant.getStarted');

      return (
        <div style={{ marginTop: '20px', maxWidth: '500px', padding: '0 25px' }}>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div>
                <h3 style={{ padding: '0 0 10px' }}>
                  {getLandlordVerbiageOrTranslatedString('onboarding.tenant.confirmYourAccount', {
                    name: this.props.initialValues[this.props.greetingNameType],
                  })}
                </h3>
                <div className="error-message">{this.state.errorMessage}</div>
              </div>
              <RegistrationForm
                onSubmit={this.register}
                isRegistering={this.state.isRegistering}
                submitMessage={submitMessage}
                initialValues={this.props.initialValues}
                emailDisabled={true}
                updateLanguage={updateLanguage}
                forceUpdate={() => this.forceUpdate()}
              />
            </CardContent>
          </Card>
        </div>
      );
    }
  }
);
